<template>
      <b-nav-item-dropdown right no-caret>
        <template slot="button-content">
          <img src="static/img/avatars/9.jpg" class="img-avatar" alt=""> {{this.username}}
        </template>
        <b-dropdown-header tag="div" class="text-center"><strong>Account</strong></b-dropdown-header>
        <b-dropdown-item @click="logout"><i class="fa fa-power-off"></i> Logout</b-dropdown-item>
      </b-nav-item-dropdown>
</template>
<script>
  export default {
    name: 'header-dropdown-accnt',
    data: () => {
      return {
        username: '',
        itemsCount: 42
      }
    },
    methods: {
      logout () {
        this.$http.post(this.API_ENDPOINT + '/operator/logout', {headers: { 'Content-Type': 'application/json' }}).then(response => {
          window.sessionStorage.clear()
          this.$router.go('/')
        }).catch(err => {
          console.log('this is an error ', err)
        })
      }
    },
    created () {
      if (window.sessionStorage.getItem('user')) {
        let user = JSON.parse(window.sessionStorage.getItem('user'))
        this.username = user.username
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Header/HeaderDropdownAccnt.vue